import { defineComponent as _defineComponent } from 'vue'
import { buryPoint } from '@/apis/common/buryPoint'
import { surplusLock, surplusTransfer } from '@/apis/surplusManage/index'
import {
  deleteSurplusApi,
  restoreSurplusApi,
  searchSurplusRecycle,
} from '@/apis/surplusManage/index'
import DrawSupplus from '@/components/draw/drawSupplus.vue'
import GBaseModal from '@/components/g-base-modal.vue'
import GTView from '@/components/translateComp/g-t-view.vue'
import router from '@/router'
import EventBus from '@/util/bus'
import { EventBusKey } from '@/util/bus'
import {
  checkColorIsExist,
  checkMatCodeIsExist,
  matchHighlightBoardName,
  translate,
} from '@/util/commonFun'
import { operateRecordTableType } from '@/util/configure'
import { message } from 'ant-design-vue'
import { computed, onMounted, onUnmounted, ref } from 'vue'
import Vue from 'vue'

import { buryPointApi, genFinalRecord, toDecimal } from '../../util/commonFuncs'
import { recycleBinColumns } from './data/data'


export default /*#__PURE__*/_defineComponent({
  __name: 'recycleBin',
  setup(__props: any) {

const props = __props as {}


/** 余料库部分翻译函数 */
function t(k: string) {
  return translate('surplusPage.' + k)
}
/** 公共部分翻译函数 */
function ct(k: string, val?: any) {
  return translate('common.' + k, val)
}
function translateDeleteReason(reason: string | number | null | undefined) {
  if (reason === undefined || reason === null || reason === '') {
    return ''
  }
  const key = `surplusPage.deleteReason-${reason}`
  const result = translate(key)
  return result === key ? '' : result
}

const notAbleDelete = computed(() => {
  return selectedSurplusList.value.length === 0
})

function getOperateSurplusListByIds(ids: number[]) {
  const itemMap = new Map<number, any>()
  const sourceList = [
    ...allSelectedSurplusList.value,
    ...selectedSurplusList.value,
    ...recycleList.value,
  ]
  sourceList.forEach((item: any) => {
    if (!itemMap.has(item.id)) {
      itemMap.set(item.id, item)
    }
  })
  return ids
    .map((id) => itemMap.get(id))
    .filter((item): item is any => Boolean(item))
}

function getTexDirText(texDir: string) {
  if (texDir == 'normal') {
    return Vue.prototype.$translateLang('竖纹')
  } else if (texDir == 'reverse') {
    return Vue.prototype.$translateLang('横纹')
  } else {
    return Vue.prototype.$translateLang('无纹理')
  }
}
function getHighlightSurfaceText(highlight_surface: number) {
  if (highlight_surface == 1) {
    return Vue.prototype.$translateLang('正面')
  } else if (highlight_surface == 2) {
    return Vue.prototype.$translateLang('反面')
  } else {
    return Vue.prototype.$translateLang('无正反')
  }
}
const surplusRecordKeys = [
  'surplus_name',
  'shape',
  'type',
  'color',
  'thick',
  'long',
  'width',
  'min_long',
  'min_width',
  'area',
  'surplus_trim_edge',
  'amount',
  'is_high_gloss_plank',
  'branch_name',
  'remark',
]

/** 格式化余料操作记录表格数据 */
function formatSurplusRecordItem(item: any) {
  if (!item) return null
  return {
    ...item,
    surplus_name: item.name,
    shape: item.shape == 0 ? '矩形' : 'L形',
    type: item.type.replaceAll('高光_', ''),
    is_high_gloss_plank: item.type.includes('高光') ? '高光板' : '非高光板',
    branch_name: item.branch_name ?? '-',
    surplus_trim_edge:
      item.surplus_trim_edge ??
      (item.trimmingMethod === 'custom'
        ? item.isCustomTrim
          ? `${item.topTrim},${item.bottomTrim},${item.leftTrim},${item.rightTrim}`
          : item.trimValue
        : ''),
  }
}

function saveRecycleBinOperateRecord(action: '删除' | '还原', ids: number[]) {
  const items = getOperateSurplusListByIds(ids)
  if (!items.length) {
    return
  }
  const recordList = items
    .map((item) => formatSurplusRecordItem(item))
    .filter(Boolean)
  const isDelete = action === '删除'

  genFinalRecord(
    {
      key: '余料回收站',
      operateArr: [
        {
          key: '余料',
          dataArr: [
            {
              type: 'table',
              list: isDelete ? [] : recordList,
              oriList: isDelete ? recordList : [],
              keys: surplusRecordKeys,
              tableType: operateRecordTableType.SURPLUS_DEPOT_TABLE,
              idKey: 'id',
            },
          ],
        },
      ],
    },
    'surplus-management',
    -2,
    () => {
      console.log('saveRecycleBinOperateRecord')
    }
  )
}
// 记录输入的搜索关键词
const keyWord = ref('')
// 记录选择的搜索类型
const searchType = ref('name')

const handleChange = (e: any) => {
  let timer = null
  if (!e.target.value) {
    if (timer !== null) {
      clearTimeout(timer)
    }
    timer = setTimeout(() => {
      page.value = 1 //time用来控制事件的触发
      getSupplusList()
    }, 500)
  }
}
const getPopupContainer = () => {
  // 余料详情popover方法-浮层渲染父节点，默认渲染到 body 上
  return document.body
}

const handleGoBack = () => {
  router.go(-1)
}
// 记录绘制点位
const drawObj = ref({
  width: 172,
  long: 257,
  min_width: 0,
  min_long: 0,
})
const drawScale = ref(1)
// 记录余料回收列表
const recycleList = ref([])
// 记录是矩形还是L形
const activeShape = ref<string>('全部')
// 记录选中的板材类型
const activeMatcode = ref<string>('全部')
const allMatcodeList = ref([])
// 记录选中的板材厚度
const activeThick = ref('全部')
const allThickList = ref([])

const activeColor = ref('全部')

const allColorList = ref([])

// 重置筛选条件
const resetClassify = () => {
  page.value = 1
  activeThick.value = '全部'
  activeShape.value = '全部'
  activeMatcode.value = '全部'
  activeColor.value = '全部'
  keyWord.value = ''
  clearAllSelection()
  getSupplusList()
}
const page = ref(1)
// 记录当前一页显示条数
const pageSize = ref(10)
// 记录可切换的pageSize
const pageSizeOptions = ['10', '20', '30', '40', '50']
// 记录总条数
const totalSupplus = ref(1)
// 切换每页显示条数
const onShowSizeChange = (_current: number, newPageSize: number) => {
  pageSize.value = newPageSize
  let currentPage
  if (page.value > Math.ceil(totalSupplus.value / newPageSize)) {
    currentPage = Math.ceil(totalSupplus.value / newPageSize)
  } else {
    currentPage = page.value
  }
  getSupplusList(currentPage)
}
// 是否全选板件
const isSelectAll = ref<boolean>(false)
const isSelectAllSurplus = ref<boolean>(false)
const allSelectedSurplusList = ref<any[]>([])
const selectedRowKeys = ref<number[]>([])
const selectAllTypeList = ref<string[]>([])
const pageSelectedKeysMap = ref<Record<number, number[]>>({})
const prevPage = ref(1)
const shapeMap = {
  L: 1,
  specialShape: 2,
  rect: 0,
}

const isIndeterminate = computed(() => {
  const hasSelected = selectedRowKeys.value.length > 0
  const allSelected =
    recycleList.value.length > 0 &&
    recycleList.value.every((item: any) =>
      selectedRowKeys.value.includes(item.id)
    )
  return hasSelected && !allSelected && !isSelectAll.value
})

function buildListParams(pageNum: number, limit?: number) {
  const param: Record<string, any> = {
    page: pageNum,
    limit: limit || pageSize.value,
  }
  if (activeShape.value != '全部' && activeShape.value != 'all') {
    param.shape = shapeMap[activeShape.value as keyof typeof shapeMap]
  }
  if (activeThick.value != '全部') {
    param.thick = activeThick.value
  }
  if (activeMatcode.value != '全部') {
    param.matCode = activeMatcode.value
  }
  if (activeColor.value != '全部') {
    param.color = activeColor.value
  }
  if (keyWord.value != '') {
    param[searchType.value] = keyWord.value
  }
  return param
}

function selectAllCurrentPage() {
  const currentPageKeys = recycleList.value.map((item: any) => item.id)

  selectedRowKeys.value = currentPageKeys
  pageSelectedKeysMap.value[page.value] = [...currentPageKeys]
  recycleList.value.forEach((item: any) => {
    item.isSelected = true
  })

  selectedSurplusList.value = selectedSurplusList.value.filter(
    (item: any) => !currentPageKeys.includes(item.id)
  )
  selectedSurplusList.value = [
    ...selectedSurplusList.value,
    ...recycleList.value,
  ]

  isSelectAll.value = true
  selectAllTypeList.value = isSelectAllSurplus.value
    ? ['port', 'all']
    : ['port']
}

function cancelSelectAllCurrentPage() {
  selectedRowKeys.value = []
  recycleList.value.forEach((item: any) => {
    item.isSelected = false
  })
  selectedSurplusList.value = []
  isSelectAll.value = false
  selectAllTypeList.value = isSelectAllSurplus.value ? ['all'] : []
}

function clearCurrentPageSelection() {
  selectedRowKeys.value = []
  recycleList.value.forEach((item: any) => {
    item.isSelected = false
  })
  selectedSurplusList.value = []
  selectAllTypeList.value = []
  isSelectAll.value = false
  delete pageSelectedKeysMap.value[page.value]
}

function clearAllSelection(needReload = false) {
  isSelectAllSurplus.value = false
  allSelectedSurplusList.value = []
  pageSelectedKeysMap.value = {}
  selectedRowKeys.value = []
  selectedSurplusList.value = []
  isSelectAll.value = false
  selectAllTypeList.value = []
  if (needReload) {
    getSupplusList(page.value)
  }
}

function getDefaultSelectAllType() {
  if (isSelectAllSurplus.value) {
    return ['port', 'all']
  }
  return ['port']
}

function updateCurrentPageInSelectAllMode(shouldSelect: boolean) {
  const currentPageKeys = recycleList.value.map((item: any) => item.id)

  if (shouldSelect) {
    currentPageKeys.forEach((id) => {
      if (!selectedRowKeys.value.includes(id)) {
        selectedRowKeys.value.push(id)
      }
    })
    isSelectAll.value = true
    selectAllTypeList.value = ['port', 'all']
  } else {
    currentPageKeys.forEach((id) => {
      const index = selectedRowKeys.value.indexOf(id)
      if (index > -1) {
        selectedRowKeys.value.splice(index, 1)
      }
    })
    isSelectAll.value = false
    selectAllTypeList.value = ['all']
  }

  allSelectedSurplusList.value.forEach((item: any) => {
    item.isSelected = currentPageKeys.includes(item.id)
      ? shouldSelect
      : item.isSelected
  })

  recycleList.value.forEach((item: any) => {
    item.isSelected = shouldSelect
  })

  selectedSurplusList.value = allSelectedSurplusList.value.filter((item: any) =>
    selectedRowKeys.value.includes(item.id)
  )
}

function switchSelectAllType(newType: string) {
  if (newType === 'all') {
    if (isSelectAllSurplus.value) {
      clearAllSelection(true)
      return
    }
    isSelectAllSurplus.value = true
    selectAllTypeList.value = ['port', 'all']
    allSelectedSurplusList.value = []
    selectedRowKeys.value = []
    selectedSurplusList.value = []
    const limit = totalSupplus.value > 0 ? totalSupplus.value : 10000
    getSupplusList(1, false, limit, true)
    return
  }

  if (newType === 'port') {
    if (isSelectAll.value) {
      cancelSelectAllCurrentPage()
      return
    }
    selectAllCurrentPage()
  }
}

function handleSelectAllTypeChange(checkedValues: string[]) {
  if (
    checkedValues.includes('all') &&
    !checkedValues.includes('port') &&
    !isSelectAllSurplus.value
  ) {
    checkedValues.push('port')
  }
  selectAllTypeList.value = [...checkedValues]

  const hasAll = checkedValues.includes('all')
  const hasPort = checkedValues.includes('port')
  const isEmpty = checkedValues.length === 0

  if (hasAll) {
    if (!isSelectAllSurplus.value) {
      switchSelectAllType('all')
    } else {
      updateCurrentPageInSelectAllMode(hasPort)
    }
    return
  }

  if (hasPort) {
    if (isSelectAllSurplus.value) {
      isSelectAllSurplus.value = false
      allSelectedSurplusList.value = []
      selectAllCurrentPage()
    } else {
      switchSelectAllType('port')
    }
    return
  }

  if (isEmpty) {
    if (isSelectAllSurplus.value) {
      clearAllSelection(true)
    } else {
      clearCurrentPageSelection()
    }
    return
  }

  if (isSelectAllSurplus.value) {
    clearAllSelection(true)
  }
}

function handleChangeTotalPage() {
  selectAllTypeList.value = []
  isSelectAllSurplus.value = false
}

function handleHeaderCheckboxChange(e: { target: { checked: boolean } }) {
  const checked = e.target.checked
  if (checked) {
    selectAllTypeList.value = getDefaultSelectAllType()
  } else if (isSelectAllSurplus.value) {
    clearAllSelection(true)
  } else {
    clearCurrentPageSelection()
  }
}

function handleSelectAllSurplusMode(formattedData: any[]) {
  formattedData.forEach((item) => {
    item.isSelected = true
  })
  allSelectedSurplusList.value = formattedData
  const startIndex = (page.value - 1) * pageSize.value
  const endIndex = startIndex + pageSize.value
  recycleList.value = formattedData.slice(startIndex, endIndex)
  selectedSurplusList.value = [...allSelectedSurplusList.value]
  selectedRowKeys.value = allSelectedSurplusList.value.map((item) => item.id)
  isSelectAll.value =
    recycleList.value.length > 0 &&
    recycleList.value.every((item: any) => item.isSelected)
  message.success(`已全选 ${allSelectedSurplusList.value.length} 条数据`)
}

function syncSelectionFromAllSelected() {
  const allSelectedIds = allSelectedSurplusList.value.map((item) => item.id)
  recycleList.value.forEach((item: any) => {
    item.isSelected = allSelectedIds.includes(item.id)
  })
  selectedRowKeys.value = recycleList.value
    .filter((item: any) => allSelectedIds.includes(item.id))
    .map((item: any) => item.id)
  isSelectAll.value =
    recycleList.value.length > 0 &&
    recycleList.value.every((item: any) => allSelectedIds.includes(item.id))
  updateSelectAllTypeList()
  updateSelectedSurplusListFromAllSelected(allSelectedIds)
}

function restoreCurrentPageSelection() {
  if (pageSelectedKeysMap.value[page.value]) {
    selectedRowKeys.value = [...pageSelectedKeysMap.value[page.value]]
    recycleList.value.forEach((item: any) => {
      item.isSelected = selectedRowKeys.value.includes(item.id)
    })
    updateSelectedSurplusList()
    updateIsSelectAll()
    updateSelectAllTypeList()
    return
  }

  selectedRowKeys.value = recycleList.value
    .filter((item: any) => item.isSelected)
    .map((item: any) => item.id)
  recycleList.value.forEach((item: any) => {
    item.isSelected = selectedRowKeys.value.includes(item.id)
  })
  updateSelectedSurplusList()
  updateIsSelectAll()
  if (!isSelectAll.value && selectAllTypeList.value.includes('port')) {
    selectAllTypeList.value = selectAllTypeList.value.filter(
      (item) => item !== 'port'
    )
  }
}

function updateSelectedSurplusList() {
  const currentPageSelectedIds = recycleList.value
    .filter((item: any) => selectedRowKeys.value.includes(item.id))
    .map((item: any) => item.id)
  selectedSurplusList.value = selectedSurplusList.value.filter(
    (item: any) => !currentPageSelectedIds.includes(item.id)
  )
  const currentPageSelected = recycleList.value.filter((item: any) =>
    selectedRowKeys.value.includes(item.id)
  )
  selectedSurplusList.value = [
    ...selectedSurplusList.value,
    ...currentPageSelected,
  ]
}

function updateSelectedSurplusListFromAllSelected(allSelectedIds: number[]) {
  const currentPageSelected = recycleList.value.filter((item: any) =>
    allSelectedIds.includes(item.id)
  )
  const currentPageIds = recycleList.value.map((item: any) => item.id)
  selectedSurplusList.value = selectedSurplusList.value.filter(
    (item: any) => !currentPageIds.includes(item.id)
  )
  selectedSurplusList.value = [
    ...selectedSurplusList.value,
    ...currentPageSelected,
  ]
}

function updateIsSelectAll() {
  isSelectAll.value =
    recycleList.value.length > 0 &&
    recycleList.value.every((item: any) =>
      selectedRowKeys.value.includes(item.id)
    )
}

function updateSelectAllTypeList() {
  if (isSelectAll.value) {
    if (!selectAllTypeList.value.includes('port')) {
      selectAllTypeList.value = [...selectAllTypeList.value, 'port']
    }
  } else if (selectAllTypeList.value.includes('port')) {
    selectAllTypeList.value = selectAllTypeList.value.filter(
      (item) => item !== 'port'
    )
  }
}
// 选择的数据
const selectedSurplusList = ref<any[]>([])
// 显示删除余料弹窗
const handleShowDeleteDialog = () => {
  showDeleteDialog()
}

// 切换页码
const changeCurrentPage = () => {
  if (isSelectAllSurplus.value && allSelectedSurplusList.value.length > 0) {
    const startIndex = (page.value - 1) * pageSize.value
    const endIndex = startIndex + pageSize.value
    const currentPageData = allSelectedSurplusList.value.slice(
      startIndex,
      endIndex
    )
    currentPageData.forEach((item: any) => {
      item.isSelected = selectedRowKeys.value.includes(item.id)
    })
    recycleList.value = currentPageData
    isSelectAll.value =
      recycleList.value.length > 0 &&
      recycleList.value.every((item: any) =>
        selectedRowKeys.value.includes(item.id)
      )
    if (isSelectAll.value) {
      if (!selectAllTypeList.value.includes('port')) {
        selectAllTypeList.value = ['port', 'all']
      }
    } else if (selectAllTypeList.value.includes('port')) {
      selectAllTypeList.value = ['all']
    }
    prevPage.value = page.value
    return
  }

  if (
    selectAllTypeList.value.includes('port') &&
    prevPage.value !== page.value
  ) {
    const currentPageSelectedKeys = recycleList.value
      .filter((item: any) => item.isSelected)
      .map((item: any) => item.id)
    pageSelectedKeysMap.value[prevPage.value] = [...currentPageSelectedKeys]
  }
  prevPage.value = page.value
  getSupplusList(page.value)
}
// 记录输入的跳转页码
const jumpPage = ref('')
// 页码输入限制
const pageInputCheck = () => {
  jumpPage.value = jumpPage.value.replace(/^(0+)|[^\d]+/g, '')
}
// 跳转至指定页
const jumpToPage = () => {
  if (jumpPage.value != '') {
    const targetPage = Number(jumpPage.value)
    if (
      !isSelectAllSurplus.value &&
      selectAllTypeList.value.includes('port') &&
      prevPage.value !== targetPage
    ) {
      const currentPageSelectedKeys = recycleList.value
        .filter((item: any) => item.isSelected)
        .map((item: any) => item.id)
      pageSelectedKeysMap.value[prevPage.value] = [...currentPageSelectedKeys]
    }
    prevPage.value = targetPage
    page.value = targetPage
    getSupplusList(page.value)
  }
}
const getSupplusList = (
  pageNum: number = 1,
  isGetSurStore?: boolean,
  limit?: number,
  getAll = false
) => {
  if (page.value !== pageNum) {
    prevPage.value = page.value
  }
  page.value = pageNum
  if (!isGetSurStore && !isSelectAllSurplus.value) {
    isSelectAll.value = false
  }
  if (keyWord.value != '' && !getAll) {
    page.value = 1
    pageNum = 1
  }
  const param = buildListParams(pageNum, limit)
  if (getAll) {
    param.get_all = true
  }
  searchSurplusRecycle(param).then((res: any) => {
    if (res.status === 1) {
      const formattedData =
        res.data?.data?.map((item: any) => formatSurplusItem(item)) ?? []

      if (!isGetSurStore) {
        if (
          isSelectAllSurplus.value &&
          (getAll || (limit && limit > pageSize.value))
        ) {
          handleSelectAllSurplusMode(formattedData)
        } else {
          recycleList.value = formattedData
          if (
            isSelectAllSurplus.value &&
            allSelectedSurplusList.value.length > 0
          ) {
            syncSelectionFromAllSelected()
          } else if (!isSelectAllSurplus.value) {
            restoreCurrentPageSelection()
          }
        }
      }

      updateSurplusListData(res.data)
    } else {
      message.error(res.msg)
    }
  })
}
/** 解析余料 path，接口可能返回 JSON 字符串 */
function parseSurplusPath(path: unknown) {
  if (!path) return undefined
  if (Array.isArray(path)) return path
  if (typeof path === 'string') {
    try {
      const parsed = JSON.parse(path)
      return Array.isArray(parsed) ? parsed : undefined
    } catch {
      return undefined
    }
  }
  return undefined
}
// 更新余料列表相关数据
const updateSurplusListData = (data) => {
  totalSupplus.value = data.total
  allMatcodeList.value = data.mat_code_list?.filter((item) => item)
  allThickList.value = data.thick_list?.filter((item) => item)
  allColorList.value = data.color_list?.map((item) => ({
    label: item,
    value: item,
  }))
}
// 格式化单个余料项
const formatSurplusItem = (item) => {
  const shapeObj = {
    0: 'common.rect',
    1: 'common.Ltype',
    2: 'common.isSpecial',
  }
  const formatted = { ...item }
  // 翻译
  formatted.surplusType = shapeObj[formatted.shape]
  formatted.isSelected = false
  // 如果是柜柜添加的余料, 则不显示备注信息, 且不可编辑备注信息
  formatted.fromGg = formatted.ggid && formatted.ggid.length == 4
  // 设置默认值
  formatted.min_long = formatted.min_long || 0
  formatted.min_width = formatted.min_width || 0
  // 格式化面积
  const area = Number(formatted.area)
  if (area != 0) {
    formatted.area = area.toFixed(2)
  }
  // 处理高光别名
  if (formatted.type) {
    const arrs = formatted.type.split('_')
    if (arrs.length > 1) {
      const highGlossName = matchHighlightBoardName(arrs[1], false)
      if (formatted.type.startsWith(`${highGlossName}_`)) {
        formatted.type = formatted.type.replace(`${highGlossName}_`, '高光_')
      }
    }
  }
  // 高光板属性
  formatted.is_high_gloss_plank = formatted.type?.startsWith('高光_') ? 1 : 0
  function resetTrim(
    formatted,
    vals = ['', '', '', ''],
    trimValue = '',
    isCustom = false
  ) {
    const [top, bottom, left, right] = vals
    Object.assign(formatted, {
      topTrim: top,
      bottomTrim: bottom,
      leftTrim: left,
      rightTrim: right,
      trimValue,
      isCustomTrim: isCustom,
    })
  }

  if (formatted.trimming_method === 'custom') {
    const edge = formatted.surplus_trim_edge
    const isCustom = edge.includes(',')
    isCustom
      ? resetTrim(formatted, edge.split(','), '', true)
      : resetTrim(formatted, ['', '', '', ''], edge, false)
  } else {
    resetTrim(formatted)
  }
  formatted.trimmingMethod = formatted.trimming_method
  delete formatted.surplus_trim_edge
  delete formatted.trimming_method
  const parsedPath = parseSurplusPath(formatted.path)
  if (parsedPath) {
    formatted.path = parsedPath
  } else if (formatted.path) {
    delete formatted.path
  }
  return formatted
}
// 当前点击余料
const currentClickSurplus = ref({})
// 表格行点击事件
const handleClickTableRow = (row: {}, index: any) => {
  return {
    on: {
      click: () => {
        currentClickSurplus.value = row
      },
    },
  }
}

// 显示余料绘制
const showSupplusShape = (visible: any, supplus: any) => {
  if (visible) {
    if (supplus.long > 257 || supplus.width > 172) {
      const scaleY = supplus.long / 257
      const scaleX = supplus.width / 172
      drawScale.value = scaleX >= scaleY ? scaleX : scaleY
    } else {
      drawScale.value = 1
    }
    const path = parseSurplusPath(supplus.path)
    drawObj.value = {
      long: Number(supplus.long),
      width: Number(supplus.width),
      min_long: supplus.min_long == '' ? 0 : Number(supplus.min_long),
      min_width: supplus.min_width == '' ? 0 : Number(supplus.min_width),
      ...(path?.length ? { path: [...path] } : {}),
    }
  }
}
// 显示删除确认弹框
const isShowDeleteDialog = ref<boolean>(false)
// 显示删除余料弹窗
const showDeleteDialog = (val: any) => {
  if (val) {
    deleteIds.value = [val.id]
  } else {
    deleteIds.value = selectedSurplusList.value.map((item: any) => item.id)
  }
  isShowDeleteDialog.value = true
}
const deleteIds = ref([])
// 确认删除余料
const confirmDeleteSupplus = () => {
  deleteSurplusApi({
    ids: deleteIds.value,
  }).then((res) => {
    if (res.status === 1) {
      saveRecycleBinOperateRecord('删除', [...deleteIds.value])
      message.success('删除成功')
      clearAllSelection()
      getSupplusList(page.value)
      buryPointApi('supplus_storage', 'recycle_bin_delete')
    } else {
      message.error(res.msg)
    }
    deleteIds.value = []
  })
  isShowDeleteDialog.value = false
}

const isShowRestoreDialog = ref<boolean>(false)
const restoreIds = ref<number[]>([])

const restoreDialogContain = computed(() => {
  return translate('materialPage.restoreConfirm')
})

function showRestoreDialog(val?: any) {
  if (val) {
    restoreIds.value = [val.id]
  } else {
    restoreIds.value = selectedSurplusList.value.map((item: any) => item.id)
  }
  isShowRestoreDialog.value = true
}

function handleShowRestoreDialog() {
  showRestoreDialog()
}

function confirmRestoreSupplus() {
  restoreSurplusApi({
    ids: restoreIds.value,
  }).then((res) => {
    if (res.status === 1) {
      saveRecycleBinOperateRecord('还原', [...restoreIds.value])
      message.success('还原成功')
      clearAllSelection()
      getSupplusList(page.value)
      buryPointApi('supplus_storage', 'recycle_bin_restore')
    } else {
      message.error(res.msg)
    }
    restoreIds.value = []
  })
  isShowRestoreDialog.value = false
}

// 选中单个余料（v-model 已更新 isSelected，此处只同步选中列表）
const selectedSurplus = (item: any) => {
  if (isSelectAllSurplus.value && !item.isSelected) {
    isSelectAllSurplus.value = false
    allSelectedSurplusList.value = []
    selectAllTypeList.value = []
    pageSelectedKeysMap.value = {}
  }

  if (item.isSelected) {
    if (!selectedRowKeys.value.includes(item.id)) {
      selectedRowKeys.value.push(item.id)
    }
  } else {
    const index = selectedRowKeys.value.indexOf(item.id)
    if (index > -1) {
      selectedRowKeys.value.splice(index, 1)
    }
  }

  isSelectAll.value =
    recycleList.value.length > 0 &&
    recycleList.value.every((row: any) =>
      selectedRowKeys.value.includes(row.id)
    )

  if (isSelectAllSurplus.value) {
    selectedSurplusList.value = allSelectedSurplusList.value.filter((i: any) =>
      selectedRowKeys.value.includes(i.id)
    )
    selectedSurplusList.value.forEach((row: any) => {
      row.isSelected = selectedRowKeys.value.includes(row.id)
    })
  } else {
    const currentPageIds = recycleList.value.map((i: any) => i.id)
    const currentPageSelectedIds = recycleList.value
      .filter((i: any) => selectedRowKeys.value.includes(i.id))
      .map((i: any) => i.id)

    selectedSurplusList.value.forEach((row: any) => {
      if (currentPageIds.includes(row.id)) {
        row.isSelected = currentPageSelectedIds.includes(row.id)
      }
    })

    selectedSurplusList.value = selectedSurplusList.value.filter(
      (i: any) =>
        !currentPageIds.includes(i.id) || currentPageSelectedIds.includes(i.id)
    )

    const existingIds = selectedSurplusList.value.map((i: any) => i.id)
    const currentPageSelected = recycleList.value.filter(
      (i: any) =>
        selectedRowKeys.value.includes(i.id) && !existingIds.includes(i.id)
    )
    selectedSurplusList.value = [
      ...selectedSurplusList.value,
      ...currentPageSelected,
    ]

    if (selectAllTypeList.value.includes('port')) {
      pageSelectedKeysMap.value[page.value] = [...selectedRowKeys.value]
    }
  }

  if (selectedRowKeys.value.length === 0) {
    selectAllTypeList.value = []
    delete pageSelectedKeysMap.value[page.value]
  }
}

// 翻译余料表格表头列
const recycleBinColumnList = ref<any[]>([...recycleBinColumns])
const updateTransSurplusTable = () => {
  recycleBinColumnList.value = recycleBinColumnList.value.map((item) => {
    if (!['select', 'branch_name', 'surplus_trim_edge'].includes(item.key)) {
      return {
        ...item,
        title: translate(item.translateKey),
        // 自定义头部单元格
        customHeaderCell: () => ({
          attrs: {
            // 可以在这里添加额外的属性，比如 title
            title: translate(item.translateKey),
          },
        }),
      }
    } else {
      return item
    }
  })
}
/**
 * @description 显示修边文本
 * @param record 余料数据
 * */
const showTrimText = (record) => {
  // L形余料和异形余料读默认标准板的修边
  if (record.shape !== 0) return '/'
  if (record.trimmingMethod == 'follow') {
    return '/'
  } else {
    // 读取surplus_trim_edge的数据
    return record.isCustomTrim
      ? `上${record.topTrim}-下${record.bottomTrim}-左${record.leftTrim}-右${record.rightTrim}`
      : record.trimValue
  }
}

const addBusEvent = () => {
  EventBus.$on(EventBusKey.TRANSLATE, updateTransSurplusTable)
}

const removeBusEvent = () => {
  EventBus.$off(EventBusKey.TRANSLATE, updateTransSurplusTable)
}
onMounted(() => {
  updateTransSurplusTable()
  addBusEvent()
  getSupplusList()
})
onUnmounted(() => {
  removeBusEvent()
})

return { __sfc: true,props, t, ct, translateDeleteReason, notAbleDelete, getOperateSurplusListByIds, getTexDirText, getHighlightSurfaceText, surplusRecordKeys, formatSurplusRecordItem, saveRecycleBinOperateRecord, keyWord, searchType, handleChange, getPopupContainer, handleGoBack, drawObj, drawScale, recycleList, activeShape, activeMatcode, allMatcodeList, activeThick, allThickList, activeColor, allColorList, resetClassify, page, pageSize, pageSizeOptions, totalSupplus, onShowSizeChange, isSelectAll, isSelectAllSurplus, allSelectedSurplusList, selectedRowKeys, selectAllTypeList, pageSelectedKeysMap, prevPage, shapeMap, isIndeterminate, buildListParams, selectAllCurrentPage, cancelSelectAllCurrentPage, clearCurrentPageSelection, clearAllSelection, getDefaultSelectAllType, updateCurrentPageInSelectAllMode, switchSelectAllType, handleSelectAllTypeChange, handleChangeTotalPage, handleHeaderCheckboxChange, handleSelectAllSurplusMode, syncSelectionFromAllSelected, restoreCurrentPageSelection, updateSelectedSurplusList, updateSelectedSurplusListFromAllSelected, updateIsSelectAll, updateSelectAllTypeList, selectedSurplusList, handleShowDeleteDialog, changeCurrentPage, jumpPage, pageInputCheck, jumpToPage, getSupplusList, parseSurplusPath, updateSurplusListData, formatSurplusItem, currentClickSurplus, handleClickTableRow, showSupplusShape, isShowDeleteDialog, showDeleteDialog, deleteIds, confirmDeleteSupplus, isShowRestoreDialog, restoreIds, restoreDialogContain, showRestoreDialog, handleShowRestoreDialog, confirmRestoreSupplus, selectedSurplus, recycleBinColumnList, updateTransSurplusTable, showTrimText, addBusEvent, removeBusEvent, DrawSupplus, GBaseModal, GTView }
}

})